// extracted by mini-css-extract-plugin
export const accountBadgeCell = "BalanceAccountSettingsModule__accountBadgeCell__nZi+h CommonRowMobile__spanRow__2pfr+ font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const accountsTable = "BalanceAccountSettingsModule__accountsTable__wVuWa";
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "BalanceAccountSettingsModule__body__5o-Dk";
export const bold = "700";
export const cell = "BalanceAccountSettingsModule__cell__PG-bK";
export const creditAccountDetails = "BalanceAccountSettingsModule__creditAccountDetails__dYD9K";
export const debtsAccountDetails = "BalanceAccountSettingsModule__debtsAccountDetails__SCCac";
export const down = "BalanceAccountSettingsModule__down__P6tzy";
export const emptyState = "BalanceAccountSettingsModule__emptyState__shYhk";
export const footer = "BalanceAccountSettingsModule__footer__36mS8";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headerCell = "BalanceAccountSettingsModule__headerCell__3PlsL";
export const headerRow = "BalanceAccountSettingsModule__headerRow__7z8eg";
export const headerTitle = "BalanceAccountSettingsModule__headerTitle__KSk4Q";
export const lastUpdated = "BalanceAccountSettingsModule__lastUpdated__aFc--";
export const liveUpdatePreloader = "BalanceAccountSettingsModule__liveUpdatePreloader__PgKQR";
export const liveUpdatePreloaderIcon = "BalanceAccountSettingsModule__liveUpdatePreloaderIcon__1FTj-";
export const liveUpdatePreloaderText = "BalanceAccountSettingsModule__liveUpdatePreloaderText__uAnZ9";
export const medium = "500";
export const pageSizeSelectorWrapper = "BalanceAccountSettingsModule__pageSizeSelectorWrapper__eKDt1";
export const paginatorWrapper = "BalanceAccountSettingsModule__paginatorWrapper__KPbGe";
export const pointing = "BalanceAccountSettingsModule__pointing__-hadZ";
export const regular = "400";
export const responsiveTitle = "BalanceAccountSettingsModule__responsiveTitle__mib1P";
export const responsiveTitleText = "BalanceAccountSettingsModule__responsiveTitleText__toipc";
export const row = "BalanceAccountSettingsModule__row__mxrEd";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sortingWrapper = "BalanceAccountSettingsModule__sortingWrapper__9zUSR";
export const table = "BalanceAccountSettingsModule__table__DJH+9";
export const tableInner = "BalanceAccountSettingsModule__tableInner__FOxzl";
export const textCenter = "BalanceAccountSettingsModule__textCenter__BuFJa";
export const tooltipIconWrapper = "BalanceAccountSettingsModule__tooltipIconWrapper__NxZI7";
export const up = "BalanceAccountSettingsModule__up__jHyki";
export const visibleTwoColumnsUp = "BalanceAccountSettingsModule__visibleTwoColumnsUp__F8XMh";
export const white = "BalanceAccountSettingsModule__white__96uad";
export const withHelpText = "BalanceAccountSettingsModule__withHelpText__6yCai";